import { useState } from "react";
import {
  Dialog,
  DialogContent,
} from "@/components/ui/dialog";
import { Loader2 } from "lucide-react";

interface SupademoModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  email?: string;
}

export function SupademoModal({ open, onOpenChange, email }: SupademoModalProps) {
  const [isLoading, setIsLoading] = useState(true);
  
  const demoUrl = email 
    ? `https://demos.joinassembly.com/embed/cmg167b0g01n2yo0ii415jjpv?v_email=${encodeURIComponent(email)}&embed_v=2&utm_source=embed`
    : "https://demos.joinassembly.com/embed/cmfek5mfs9z5q39ozwk44xd44?embed_v=2&utm_source=embed";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-6xl w-[95vw] h-[90vh] sm:h-[80vh] p-0 overflow-hidden">
        {isLoading && (
          <div className="absolute inset-0 flex items-center justify-center bg-background z-10">
            <div className="flex flex-col items-center gap-4">
              <Loader2 className="h-8 w-8 animate-spin text-blue-600" />
              <p className="text-sm text-muted-foreground">Loading demo...</p>
            </div>
          </div>
        )}
        <iframe 
          src={demoUrl}
          title="Assembly Recognition in 30 seconds" 
          allow="clipboard-write" 
          frameBorder="0" 
          className="w-full h-full"
          allowFullScreen
          onLoad={() => setIsLoading(false)}
        />
      </DialogContent>
    </Dialog>
  );
}